<template>
    <div>
        <section id="service">
            <div>
                <h1 class="mb-4 text-center">Opt-out of {{ isPersonalProgram ? client.personal_program_name : client.program_name }}</h1>
            </div>
            <div class="container services-area page">
                <form id="resident-form" @submit.prevent="store">
                    <div class="form-item">
                        <div class="float-right"><label class="required"> Required for submission</label></div>
                        <h5>Property</h5>
                        <hr>
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <select-input v-model="form.property_id" :error="form.errors.property_id"
                                              class="pr-6 pb-8 required-field"
                                              label="Property"
                                              @change="updateAgreementText($event)">
                                    <option :value="null">---Select---</option>
                                    <option v-for="property in properties" :key="property.property_id"
                                            :value="property.property_id">{{ property.property_name }}
                                    </option>
                                </select-input>
                            </div>
                        </div>
                        <div class="mb-3">
                            <h5>Resident</h5>
                            <hr>
                        </div>

                        <div class="residents-info">
                            <div class="row mb-3" v-for="(resident, index) in form.residents">

                                <div class="row mb-3" v-if="index === 0">
                                    <div class="sub-title">Primary:</div>
                                </div>

                                <div class="col-md-3">
                                    <text-input v-model="resident.first_name"
                                                class="required-field"
                                                :error="form.errors[`residents.${index}.first_name`]" :label="index === 0 ? 'First Name': ''"
                                                maxlength="64"/>
                                </div>
                                <div class="col-md-3">
                                    <text-input v-model="resident.last_name"
                                                class="required-field"
                                                :error="form.errors[`residents.${index}.last_name`]" :label="index === 0 ? 'Last name': ''"
                                                maxlength="64"/>
                                </div>
                                <div class="col-md-3">
                                    <text-input v-model="resident.email"
                                                class="required-field"
                                                :label="index === 0 ? 'Email Address': ''"
                                                :error="form.errors[`residents.${index}.email`]" maxlength="128"/>
                                </div>
                                <div class="col-md-3">
                                    <number-input v-model="resident.tel"
                                                  class="required-field"
                                                  :label="index === 0 ? 'Phone Number' : ''"
                                                  :error="form.errors[`residents.${index}.tel`]"
                                                  numberType="phone" maxlength="14"/>
                                </div>
                                <div class="col action" v-if="index > 0">
                                    <a class="btn btn-danger btn-sm btn-block" @click="removeResident(index)"><i
                                        class="fa fa-trash-o"></i></a>
                                </div>

                                <div class="row" v-if="index === 0 && form.residents.length > 1">
                                    <div class="sub-title">Additional:</div>
                                </div>
                            </div>

                            <div class="row mb-3" v-if="form.residents.length < 10">
                                <div>
                                    <a href="javascript:void(0)" class="btn-sm btn btn-block btn-primary"
                                       @click="addResident"><i class="fa fa-plus-circle"></i> Add Resident</a>
                                </div>
                            </div>
                        </div>

                        <h5 class="mt-4">Address</h5>
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <text-input v-model="form.address_1" class="required-field" :error="form.errors.address_1"
                                            label="Insured Address" maxlength="128"/>
                            </div>
                            <div class="col-md-6">
                                <text-input v-model="form.address_2" :error="form.errors.address_2"
                                            label="Apartment Number (Optional)" maxlength="128"/>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4">
                                <text-input v-model="form.city" class="required-field" :error="form.errors.city" label="City" maxlength="64"/>
                            </div>
                            <div class="col-md-4">
                                <select-input v-model="form.state" class="required-field" :error="form.errors.state" label="State">
                                    <option :value="null">---Select---</option>
                                    <option v-for="(state, index) in states" :key="index" :value="index">{{
                                            state
                                        }}
                                    </option>
                                </select-input>
                            </div>
                            <div class="col-md-4">
                                <number-input v-model="form.zip"
                                              class="required-field"
                                              :error="form.errors.zip"
                                              label="Zip"
                                              maxlength="5"
                                              numberType="number"/>
                            </div>
                        </div>

                        <h5 v-if="!isPersonalProgram">Policy</h5>
                        <hr v-if="!isPersonalProgram">

                        <div class="row" v-if="!isPersonalProgram">
                            <div class="col-md-4">
                                <text-input v-model="form.provider" class="required-field" :error="form.errors.provider"
                                            label="Insurance Provider" maxlength="64"/>
                            </div>
                            <div class="col-md-4">
                                <text-input v-model="form.policy_number" class="required-field" :error="form.errors.policy_number"
                                            label="Policy Number" maxlength="64"/>
                            </div>
                            <div class="col-md-4">
                                <number-input v-model="form.coverage"
                                              class="required-field"
                                              :error="form.errors.coverage"
                                              label="Coverage Limit"
                                              maxlength="10"
                                              numberType="money"/>
                            </div>
                        </div>
                        <div class="row mb-3" v-if="!isPersonalProgram">
                            <div class="col-md-4">
                                <div class="form-group mb-3">
                                    <label class="form-label required" for="start_date">Start Date:</label>
                                    <datepicker id="start_date"
                                                v-model="form.start_date"
                                                inputClass="form-control date-input"
                                                :calendarButton="true"
                                                calendarButtonIcon="fa fa-calendar"
                                                :format="dateFormatter"
                                                :disabled-dates="disabledStartDates"
                                                @input="checkStartDate"/>
                                    <div v-if="form.errors.start_date" class="help-block with-errors">
                                        {{ form.errors.start_date }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" v-if="showEffectiveDate">
                                <div class="form-group mb-3">
                                    <label class="form-label" for="end_date">Effective Date:</label>
                                    <datepicker id="effective_date"
                                                v-model="form.effective_date"
                                                inputClass="form-control date-input"
                                                :calendarButton="true"
                                                calendarButtonIcon="fa fa-calendar"
                                                :format="dateFormatter"
                                                disabled/>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group mb-3">
                                    <label class="form-label required" for="end_date">End Date:</label>
                                    <datepicker id="end_date"
                                                v-model="form.end_date"
                                                inputClass="form-control date-input"
                                                :calendarButton="true"
                                                calendarButtonIcon="fa fa-calendar"
                                                :format="dateFormatter"
                                                :disabled-dates="disabledEndDates"/>
                                    <div v-if="form.errors.end_date" class="help-block with-errors">{{
                                            form.errors.end_date
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3 file-upload" v-if="!isPersonalProgram">
                            <file-input v-model="form.uploads" class="required-field" :error="form.errors.uploads || form.errors['uploads.0'] || form.errors['uploads.1'] || form.errors['uploads.2']" type="file"
                                        label="Please upload a copy of your third party liability insurance policy in pdf format. Max 5MB"
                                        accept="image/png, image/jpeg, application/pdf" size-mb="5" error-msg="Maximum file size 5MB"/>
                        </div>
                        <div class="row mb-3 file-upload" v-if="personalProgramRequirePppUpload">
                            <file-input v-model="form.uploads" class="required-field" :error="form.errors.uploads || form.errors['uploads.0'] || form.errors['uploads.1'] || form.errors['uploads.2']" type="file"
                                        label="Please upload a copy of your signed PCon Opt Out Form in pdf format. Max 5MB"
                                        accept="image/png, image/jpeg, application/pdf" size-mb="5" error-msg="Maximum file size 5MB"/>
                        </div>
                        <div class="row" v-if="isPersonalProgram&&!personalProgramRequirePppUpload">
                            <label class="smaller-text">
                                As a benefit to the Lessee, in exchange for ${{client.ppp_price}} per month, {{client.personal_program_name}} provides Lessee with ${{client.ppp_coverage}} of personal contents coverage. 
                                Lessee is not required to maintain personal contents coverage and may opt out of {{client.personal_program_name}} at any time by submission of the Lessee’s personal information to {{client.short_name}}.confirminsurance.com
                            </label>
                             <label class="smaller-text">
                                By completing personal information submission via {{client.short_name}}.confirminsurance.com, Lessee acknowledges that he or she shall not be allowed to file any claims for loss or damage under {{client.personal_program_name}} and Lessee shall be personally responsible for any and all damage to Lessee’s property. 
                                Upon execution of the submission of Lessee’s personal information, Lessee shall not be eligible for coverage under any Personal Property Protection Program until the following Contract Term. The {{client.personal_program_name}} Opt Out submission request must be completed no later than thirty (30) days prior to Lessee’s next billing cycle, to opt out of the {{client.personal_program_name}} for the subsequent month.
                            </label>
                            <text-input type="checkbox" class="required-field" v-model="form.ppp_terms" :error="form.errors.ppp_terms"
                                        label="By completing the PPP opt out form I agree to the above terms"/>
                        </div>
                        <div class="row" v-if="isPersonalProgram">
                            <text-input type="checkbox" class="required-field" v-model="form.agree_ppp" :error="form.errors.agree_ppp"
                                        :label='`I understand by completing the PPP opt out form that I am no longer covered under the ${client.personal_program_name} program provided by my property management company through ${client.personal_program_vendor}`'/>
                        </div>
                        <div class="row" v-if="!isPersonalProgram">
                            <text-input type="checkbox" class="required-field" v-model="form.agree1" :error="form.errors.agree1"
                                        :label='`My policy lists "${property_name}" as the insured residence`'/>
                        </div>
                        <div class="row" v-if="!isPersonalProgram">
                             <text-input type="checkbox" class="required-field" v-model="form.agree2" :error="form.errors.agree2"
                                        :label='`My policy includes ${client.addl_int_name}, ${client.addl_int_address}, ${client.reporting_email} as "Additional Interest", "Interested Party" or "Certificate Holder"`'/>
                        </div>
                        <div class="row" v-if="!isPersonalProgram">
                            <text-input type="checkbox" class="required-field" v-model="form.agree3" :error="form.errors.agree3"
                                        label="I certify that the policy I am submitting is currently paid and in force, and that all information I have provided is correct"/>
                        </div>
                        <div class="row" v-if="!isPersonalProgram">
                            <text-input type="checkbox" class="required-field" v-model="form.agree4" :error="form.errors.agree4"
                                        :label='`I understand that ALL requirements of the lease agreement must be met in order for the third party liability policy to be approved for removal from the ${client.program_name}. General submission of a third party liability policy does not guarantee removal from the program and/or the removal of any fees added to the ledger prior to submission`'/>
                        </div>
                        <div class="row">
                            <div>
                                <loading-button :loading="form.processing" class="btn btn-success btn-block pull-left"
                                                type="submit"><i class="fa fa-save"></i> Submit
                                </loading-button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
import moment from 'moment'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from 'vuejs-datepicker';
import NumberInput from '@/Shared/NumberInput';

export default {
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        FileInput,
        Datepicker,
        NumberInput,
    },
    layout: Layout,
    props: {
        properties: Array,
        client: Object,
        subdomain: String,
        states: Object,
    },
    metaInfo () {
      return {
        title: this.isPersonalProgram ? 'PPP Opt-Out' : 'Opt-Out'
      }
    },
    data() {
        return {
            form: this.$inertia.form({
                residents: [
                    {
                        first_name: null,
                        last_name: null,
                        email: null,
                        tel: null,
                    },
                ],
                property_id: null,
                unit_id: null,
                address: null,
                address_1: null,
                address_2: null,
                city: null,
                state: null,
                zip: null,
                provider: null,
                policy_number: null,
                coverage: null,
                start_date: null,
                effective_date: null,
                end_date: null,
                uploads: null,
                agree_ppp: null,
                ppp_terms: null,
                agree1: null,
                agree2: null,
                agree3: null,
                agree4: null,
                ppp: null,
                ppp_require_ppp_upload: null,
            }),
            units: [],
            showEffectiveDate: false,
            property_name: 'Property Name',
            to_date: '',
        }
    },
    watch: {
    },
    beforeMount(){
        this.setSomeDefaultValue()
    },
    mounted() {
        this.to_date = this.nextDay
    },
    methods: {
        store() {
            if(this.isPersonalProgram){
                this.form.post(this.route('resident.store_ppp', this.subdomain))
            }
            else{
                this.form.post(this.route('resident.store', this.subdomain))
            }           
        },
        addResident() {
            this.form.residents.push({
                first_name: null,
                last_name: null,
                email: null,
                tel: null,
            })
        },
        removeResident(index) {
            this.form.residents.splice(index, 1)
        },
        dateFormatter(date) {
            return moment(date).format('MM-DD-YYYY')
        },
        checkStartDate($value) {
            let today = moment().format('MM-DD-YYYY')
            let selected_date = moment($value, 'MM-DD-YYYY')

            this.showEffectiveDate = false
            this.form.effective_date = this.form.start_date

            if (selected_date.isBefore(today)) {
                this.showEffectiveDate = true
                this.form.effective_date = moment().format()
                this.to_date = this.nextDay
            }else{
                this.to_date = this.form.start_date
            }
        },
        updateAgreementText(e){
            let value = e.target.value
            if(value)
                this.property_name = e.target.options[e.target.selectedIndex].text;
            else
                this.property_name = 'Property Name'
        },
        // Default value
        setSomeDefaultValue(){  
            this.form.ppp = this.isPersonalProgram;   
            this.form.ppp_require_ppp_upload = this.personalProgramRequirePppUpload;

            if(this.isPersonalProgram){
                this.form.provider = 'Personal Property';
            }
        }
    },
    computed: {
        disabledStartDates() {
            if (this.form.end_date) {
                let date = this.dateFormatter(this.form.end_date)
                date = date.split('-')
                date[2] = Number(date[2]) + 1
                date = date.join('-')
                return {
                    from: new Date(this.form.end_date)
                }
            }
        },
        disabledEndDates() {
            return {
                to: this.to_date
            }
        },
        nextDay(){
            return new Date(moment().add(1,'days').format('MM-DD-YYYY'))
        },
        isPersonalProgram(){
            return this.client.personal_program_name && window.location.pathname === '/ppp-opt-out';
        },
        personalProgramRequirePppUpload(){
            return this.isPersonalProgram && this.client.ppp_upload;
        },
    }
}
</script>
